import useCurrentUser from '..//use-current-user'
import useApi from '../use-api'
import useCacheKeys from '../use-cache-keys'
import { useInfiniteQuery } from 'react-query'
import { flatten } from 'lodash'
import moment from 'moment'

const useUserDiscussions = ({
    limit = 20
} = {}) => {
    const cacheKeys = useCacheKeys()
    const { id: userId } = useCurrentUser()
    const { api, url, endpoints, time } = useApi()

    const {
        data,
        isFetching,
        isFetchingMore,
        fetchMore,
        canFetchMore
    } = useInfiniteQuery(
        [cacheKeys.DISCUSSIONS, userId],
        (key, key2, offset = 0) =>
            api.get(url(endpoints.userDiscussions, { userId }, { offset, limit })),
        {
            getFetchMore: (lastGroup) => {
                const canGetMore = lastGroup.offset + limit < lastGroup.total
                return canGetMore ? lastGroup.offset + limit : false
            },
            staleTime: time.MINUTE,
            refetchInterval: time.SECOND * 10,
            refetchIntervalInBackground: true,
            enabled: Boolean(userId)
        }
    )
    const pages = (data || []).map(page => page.items || [])
    const userDiscussions = flatten(pages)

    const isUnread = (discussion) => !discussion.lastActiveDate || moment(discussion.lastActiveDate).isBefore(moment(discussion.lastUpdateDate))
    const hasUnread = userDiscussions.some(isUnread)
    return {
        isLoading: isFetching || isFetchingMore,
        fetchMore,
        canFetchMore,
        userDiscussions,
        hasUnread
    }
}

export default useUserDiscussions
